import { HarvestTypes, PlantsEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";
import { RmGrnItems } from "./rm-grn-items";

export class RmGrnDetailsDto {
    @ApiProperty()
    @IsOptional()
    grnItemId?: number;
    @ApiProperty()
    @IsOptional()
    grnId?: number;
    @ApiProperty()
    grnDate: any;
    @ApiProperty()
    indentId: number;
    @ApiProperty()
    @IsOptional()
    grnNumber?: string;
    @ApiProperty()
    supplierType: string;
    @ApiProperty()
    grnItemsInfo:RmGrnItems[];
    @ApiProperty()
    @IsOptional()
    plantId?: number;
    @ApiProperty()
    @IsOptional()
    subPlantId?: number;
    @ApiProperty()
    createdUser: string;
    @ApiProperty()
    @IsOptional()
    updatedUser?: string;
    @ApiProperty()
    @IsOptional()
    subPlantName?: string;
    @ApiProperty()
    @IsOptional()
    isVInspectionCompleted?: boolean;
    @ApiProperty()
    @IsOptional()
    isRmInspectionCompleted?:boolean;
    @ApiProperty()
    @IsOptional()
    isAntibioticsTestCompleted?:boolean;
    @ApiProperty()
    @IsOptional()
    harvestType?:HarvestTypes
}

